import { render } from "./WalletStakeModal.vue?vue&type=template&id=44c0a274"
import script from "./WalletStakeModal.vue?vue&type=script&lang=js"
export * from "./WalletStakeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__